// src/pages/Homepage.tsx
import { useState } from "react";
import { Link } from "react-router-dom";
import AuthHeader from "../components/AuthHeader";

const Homepage = () => {
  const [address, setAddress] = useState("");

  return (
    <div className="min-h-screen bg-[#fdf6ee] font-sans relative overflow-hidden">
      <AuthHeader />

      {/* Hero Section */}
      <main className="absolute top-[60%] left-6 transform -translate-y-1/2 text-left max-w-xl">
        <h1 className="text-5xl md:text-6xl font-extrabold mb-4 leading-tight">
          One platform. Every delivery app.
        </h1>
        <p className="text-lg text-black/80 mb-8">
          Sync your menu. Accept orders. Get paid. No delivery fees.
        </p>

        {/* Address Input */}
        <div className="flex flex-col md:flex-row items-start gap-2">
          <input
            type="text"
            placeholder="Enter your restaurant address"
            className="w-full md:w-96 px-4 py-3 rounded-full border border-gray-300"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <button className="bg-black text-white rounded-full px-6 py-3 hover:bg-gray-900 transition">
            Get Started
          </button>
        </div>

        <p className="mt-4">
          <Link to="/login" className="underline text-black text-sm">
            Already a partner? Log in
          </Link>
        </p>
      </main>
    </div>
  );
};

export default Homepage;
